
import { ThunkAction } from 'redux-thunk';
import { Http } from '../../../utils';
import {
    addToast,
    deleteToast,
    dismissResultToast,
    addErrorToast,
    deleteErrorToast,
    updateNbnTestMessage,
    updateNbnErrorMessage
} from '../../actions/update-nbn-test-result';
import {
    createTestStart,
    createTestError,
    createTestSuccess
} from '../../actions/create-test';
import { State as LoginState } from '../../../login';
import { INBNTestParams } from './parameters';
import { INBNTestCreate, INBNTestCreatePayload } from '@telstra-connect/service-requests/state/create-nbn-test';
import { loadTestResult } from '../load-nbn-test-results/load';

export function createNBNTest(params: INBNTestParams):
ThunkAction<void, LoginState.ISignInState, void> {
    return (dispatch, getState) => {
        dispatch(createTestStart());
        const props = {
            url: `/nbnDiagnostics/v1/tests`,
            state: getState(),
            body: params
        };
        return Http.post<INBNTestCreatePayload, INBNTestParams>(props)
            .then(
                (data) => {
                    dispatch(updateNbnTestMessage(data.data));
                    dispatch(addToast(data.data));
                    setTimeout(() => {
                        dispatch(deleteToast(data.data));
                    }, 20000);
                    dispatch(poll(data.data, data.data.services.map((item) => item.serviceId)));
                    dispatch(createTestSuccess([data.data]));
                }
            )
            .catch((error) => {
                const message = error.isCustom === true &&
                    error.message ? error.message : 'Error creating a new test';
                dispatch(updateNbnErrorMessage(params.services, 'COMPLETED', 'ApiError'));
                dispatch(addErrorToast(params.services, params.diagnosticName, 'Error'));
                setTimeout(() => {
                    dispatch(deleteErrorToast(params.services, params.diagnosticName, 'Error'));
                }, 20000);
                dispatch(createTestError(message));
            }
            );
    };
}
export function poll(test: INBNTestCreate, services):
ThunkAction<void, LoginState.ISignInState, void> {
    return (dispatch) => {
        setTimeout(() => dispatch(loadTestResult(test, services)), 50000);
    }
}

export function dismissToast(serviceId: string, diagnosticResult: string):
ThunkAction<void, LoginState.ISignInState, void> {
    return (dispatch) => {
        dispatch(dismissResultToast(serviceId, diagnosticResult));
    }
}
